import BatchCreateModal from "./BatchCreateModal"

export default BatchCreateModal
